/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

function isInternalLink(link: string) {
    return /^[/#?]\w*/.test(link);
}

function isMediaLink(link: string) {
    return /^(mailto|tel):/.test(link);
}

type LinkProps = {
    children: React.ReactNode;
    className?: string;
    to: string;
    shouldOpenInSameTab?: boolean;
};

export function Link({ children, className, to, shouldOpenInSameTab, ...props }: LinkProps) {
    return isInternalLink(to) ? (
        <ReactRouterLink className={className} to={to} {...props}>
            {children}
        </ReactRouterLink>
    ) : (
        <a
            href={to}
            target={isMediaLink(to) || shouldOpenInSameTab ? undefined : '_blank'}
            rel="noopener noreferrer"
            className={className}
            sx={{ background: 'transparent' }}
            {...props}
        >
            {children}
        </a>
    );
}
